<template>
  <div class="btns">
    <div class="popover-box" v-show="isFirstAddScene">
      试试添加场景页
      <div class="right-arrow"></div>
    </div>
    <div class="slides" ref="slidesEl">
      <div
        @click="openSlideBox('scenes', S_Scenes.num)"
        :class="{
          'is-active'  : ((boxData.type === 'scenes') && rightNav),
          'ban-active' : UpcomingEvents.scenes ||  (S_GlobalSearch && !S_Scenes.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Scenes.num,
            'searchTag_out' : !S_Scenes.num
          }"
        >{{S_Scenes.num}}</div>
        <i
          :class="{
            'scene-ban'    : UpcomingEvents.scenes ||  (S_GlobalSearch && !S_Scenes.num),
            'scene-active' : ((boxData.type === 'scenes') && rightNav),
            'scene'        : !((boxData.type === 'scenes') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.scenes,
          }"
        ></i>
        <span>场景</span>
        <div v-show="boxData.type === 'scenes' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('template', S_Template.num)"
        :class="{
          'is-active'  : ((boxData.type === 'template') && rightNav),
          'ban-active' : UpcomingEvents.template ||  (S_GlobalSearch && !S_Template.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Template.num,
            'searchTag_out' : !S_Template.num
          }"
        >{{S_Template.num}}</div>
        <i
          :class="{
            'template-ban'    : UpcomingEvents.template ||  (S_GlobalSearch && !S_Template.num),
            'template-active' : ((boxData.type === 'template') && rightNav),
            'template'        : !((boxData.type === 'template') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.template,
          }"
        ></i>
        <span>模板</span>
        <div v-show="boxData.type === 'template' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('bg', S_Bg.num)"
        :class="{
          'is-active'  : ((boxData.type === 'bg') && rightNav),
          'ban-active' : UpcomingEvents.bg || (S_GlobalSearch && !S_Bg.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Bg.num,
            'searchTag_out' : !S_Bg.num
          }"
        >{{S_Bg.num}}</div>

        <i
          :class="{
            'bg-ban'    : UpcomingEvents.bg || (S_GlobalSearch && !S_Bg.num),
            'bg-active' : ((boxData.type === 'bg') && rightNav),
            'bg'        : !((boxData.type === 'bg') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.bg,
          }"
        ></i>
        <span>背景</span>
        <div v-show="boxData.type === 'bg' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('text', S_Text.num)"
        :class="{
          'is-active'  : ((boxData.type === 'text') && rightNav),
          'ban-active' : UpcomingEvents.text || (S_GlobalSearch && !S_Text.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Text.num,
            'searchTag_out' : !S_Text.num
          }"
        >{{S_Text.num}}</div>

        <i
          :class="{
            'text-ban'    : UpcomingEvents.text || (S_GlobalSearch && !S_Text.num),
            'text-active' : ((boxData.type === 'text') && rightNav),
            'text'        : !((boxData.type === 'text') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.text,
          }"
        ></i>
        <span>文字</span>
        <div v-show="boxData.type === 'text' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('characters', S_Characters.num)"
        :class="{
          'is-active'  : ((boxData.type === 'characters') && rightNav),
          'ban-active' : UpcomingEvents.characters || (S_GlobalSearch && !S_Characters.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Characters.num,
            'searchTag_out' : !S_Characters.num
          }"
        >{{S_Characters.num}}</div>

        <i
          :class="{
            'character-ban' : UpcomingEvents.characters || (S_GlobalSearch && !S_Characters.num),
            'character-active' : ((boxData.type === 'characters') && rightNav),
            'character'        : !((boxData.type === 'characters') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.characters,
          }"
        ></i>
        <span>角色</span>
        <div v-show="boxData.type === 'characters' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('props', S_Props.num)"
        :class="{
          'is-active'  : ((boxData.type === 'props') && rightNav),
          'ban-active' : UpcomingEvents.props || (S_GlobalSearch && !S_Props.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Props.num,
            'searchTag_out' : !S_Props.num
          }"
        >{{S_Props.num}}</div>

        <i
          :class="{
            'prop-ban'    : UpcomingEvents.props || (S_GlobalSearch && !S_Props.num),
            'prop-active' : ((boxData.type === 'props') && rightNav),
            'prop'        : !((boxData.type === 'props') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.props,
          }"
        ></i>
        <span>道具</span>
        <div v-show="boxData.type === 'props' && rightNav" class="active-border"></div>
      </div>

      <div
        @click="openSlideBox('sound', S_Sound.num)"
        :class="{
          'is-active'  : ((boxData.type === 'sound') && rightNav),
          'ban-active' : UpcomingEvents.sound || (S_GlobalSearch && !S_Sound.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Sound.num,
            'searchTag_out' : !S_Sound.num
          }"
        >{{S_Sound.num}}</div>

        <i
          :class="{
            'music-ban'    : UpcomingEvents.sound || (S_GlobalSearch && !S_Sound.num),
            'music-active' : ((boxData.type === 'sound') && rightNav),
            'music'        : !((boxData.type === 'sound') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.sound,
          }"
        ></i>
        <span>声音</span>
        <div v-show="boxData.type === 'sound' && rightNav" class="active-border"></div>
      </div>

      <el-tooltip v-model="newVersion" :manual="true" class="item" effect="dark" placement="left">
        <div slot="content">
          上传视频，可添加为素材
          <br />或背景，快试试看吧！
        </div>
        <div
          @click="
          openSlideBox('personal', S_Personal.num);
          newVersion = false;
        "
          :class="{
          'is-active'  : ((boxData.type === 'personal') && rightNav),
          'ban-active' : UpcomingEvents.personal || (S_GlobalSearch && !S_Personal.num),
        }"
        >
          <div
            v-if="S_GlobalSearch"
            :class="{
            'searchTag'     : S_Personal.num,
            'searchTag_out' : !S_Personal.num
          }"
          >{{S_Personal.num}}</div>

          <i
            :class="{
            'personal-ban'    : UpcomingEvents.personal || (S_GlobalSearch && !S_Personal.num),
            'personal-active' : ((boxData.type === 'personal') && rightNav),
            'personal'        : !((boxData.type === 'personal') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.personal,
          }"
          ></i>
          <span>我的</span>
          <div v-show="boxData.type === 'personal' && rightNav" class="active-border"></div>
        </div>
      </el-tooltip>

      <!-- 5.5.2版 我的和团队合并-->
      <!-- <div
        @click="openSlideBox('team', S_Personal.num)"
        v-if="UserTeamInfo&& 0<=UserTeamInfo.type && UserTeamInfo.state==0"
        :class="{
          'is-active'  : ((boxData.type === 'team') && rightNav),
          'ban-active' : UpcomingEvents.team || (S_GlobalSearch && !S_Personal.num),
        }"
      >
        <div
          v-if="S_GlobalSearch"
          :class="{
            'searchTag'     : S_Personal.num,
            'searchTag_out' : !S_Personal.num
          }"
        >{{S_Personal.num}}</div>

        <i
          :class="{
            'team-ban'    : UpcomingEvents.team || (S_GlobalSearch && !S_Personal.num),
            'team-active' : ((boxData.type  === 'team') && rightNav),
            'team'        : !((boxData.type === 'team') && rightNav),
            'versionSubscript' : UserMsg.versionUpdate && UserMsg.versionData.btnData.team,
          }"
        ></i>
        <span>团队</span>
        <div v-show="boxData.type === 'team' && rightNav" class="active-border"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Analysis from "../mixins/analysis/materialBu";

export default {
  mixins: [Analysis],
  data() {
    return {
      isSettingKeyBindings: false,
      isFirstAddScene: false,
      UpcomingEvents: {
        bg: false,
        gif: false,
        text: false,
        props: false,
        sound: false,
        scenes: false,
        shapes: false,
        personal: false,
        characters: false,
        team: false
      },
      newVersion: false // 4.7.0版本入场提示
    };
  },
  props: ["boxData", "rightNav"],
  computed: {
    ...mapGetters([
      "S_Scenes",
      "S_Template",
      "S_Bg",
      "S_Text",
      "S_Characters",
      "S_Props",
      "S_Gif",
      "S_Shapes",
      "S_Sound",
      "S_Personal",
      "S_GlobalSearch",
      "MaterialPane_Size",
      "TopNav_Size",
      "Window_Size",
      "Tool_Size",
      "SpriteOperation",
      "BgOperation",
      "UserTeamInfo",
      "UserMsg"
    ])
  },
  watch: {
    SpriteOperation: function(val, oldval) {
      if (this.SpriteOperation === "swap") {
        this.UpcomingEventsFS(1);
      } else {
        this.UpcomingEventsFS(0);
      }
    },
    BgOperation: function(val, oldval) {
      if (this.BgOperation === "swap") {
        this.UpcomingEventsFS(2);
      } else {
        this.UpcomingEventsFS(0);
      }
    },
    Window_Size: {
      handler(val) {
        // this.$refs.slidesEl.style.height =
        //   window.innerHeight - this.TopNav_Size.height + "px";
      },
      deep: true
    }
  },
  mounted() {
    this.$bus.on("closeKeyBindings", data => {
      this.isSettingKeyBindings = false;
    });
    this.$bus.on("showGuidanceAddScence", () => {
      this.isFirstAddScene = true;
    });
    this.$bus.on("window_click", () => {
      if (this.isFirstAddScene) {
        this.isFirstAddScene = false;
      }
    });

    this.newVersion = this.UserMsg.versionNumber < 470; // 4.7.0版本入场提示

    // $(this.$el).find('.slides > div').eq(0).on('click', () => {
    //   this.$analysis('resource_area,click_template,素材资源区_点击_模板')
    // })

    // $(window).on("resize", () => {
    //   this.$refs.slidesEl.style.height =
    //     window.innerHeight - this.TopNav_Size.height + "px";
    // });
    // $(window).on("scroll", () => {
    //   let d = window.pageYOffset - this.TopNav_Size.height;
    //   this.$refs.slidesEl.style.top = Math.max(d, 0) + "px";
    // });
  },
  methods: {
    openSlideBox(data, num) {
      this.$bus.emit("manageMaterial_vue", { step: 0 }); // 取消批量管理
      if (this.SpriteOperation === "swap") {
        switch (data) {
          case "scenes":
          case "sound":
          case "bg":
            return;
            break;
        }
      }
      if (this.BgOperation === "swap") {
        let judgeReturn = false;
        switch (data) {
          case "team":
          case "personal":
          case "bg":
            judgeReturn = true;
            break;
        }
        if (!judgeReturn) {
          return;
        }
      }
      this.materialPushAnalysis({ type: "openSlideBox" + data });
      if (this.rightNav) {
        if (this.boxData.type !== data) {
          this.$bus.emit("materialPane_vue", { type: data });
        } else {
          this.$bus.emit("materialPane_vue", {});
        }
      } else {
        this.$bus.emit("materialPane_vue", { type: data });
        // 关闭新手引导页
        this.isFirstAddScene = false;
        if (window.localStorage.getItem("used")) return;
        window.localStorage.setItem("used", "used");
      }
    },
    UpcomingEventsFS(data) {
      switch (data) {
        case 0: // 状态清空
          this.UpcomingEvents.bg = false;
          this.UpcomingEvents.gif = false;
          this.UpcomingEvents.text = false;
          this.UpcomingEvents.props = false;
          this.UpcomingEvents.sound = false;
          this.UpcomingEvents.shapes = false;
          this.UpcomingEvents.scenes = false;
          this.UpcomingEvents.personal = false;
          this.UpcomingEvents.characters = false;
          this.UpcomingEvents.team = false;
          break;
        case 1: // 元素替换
          this.UpcomingEvents.bg = true;
          this.UpcomingEvents.sound = true; 
          this.UpcomingEvents.scenes = true;
          this.UpcomingEvents.gif = false;
          this.UpcomingEvents.text = false;
          this.UpcomingEvents.props = false;
          this.UpcomingEvents.shapes = false;
          this.UpcomingEvents.personal = false;
          this.UpcomingEvents.characters = false;
          this.UpcomingEvents.team = false;
          break;
        case 2: // 替换背景
          this.UpcomingEvents.bg = false;
          this.UpcomingEvents.personal = false;
          this.UpcomingEvents.team = false;
          this.UpcomingEvents.props = true;
          this.UpcomingEvents.text = true;
          this.UpcomingEvents.gif = true;
          this.UpcomingEvents.sound = true;
          this.UpcomingEvents.shapes = true;
          this.UpcomingEvents.scenes = true;
          this.UpcomingEvents.characters = true;
          break;
      }
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.btns {
  position: relative;
  // left: 0;
  // top: 60px;
  //z-index: 10;
  height: auto;
  width: 72px;
  //height: calc(100% - 60px);
  background-color: #d9ddea;

  .popover-box {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 70px;
    padding: 10px;
    top: 0;
    right: 70px;
    z-index: 2001;
    margin-right: 12px;
    background: #000;
    opacity: 0.6;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    .right-arrow {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      top: 29px;
      right: -6px;
      margin-bottom: 3px;
      border-width: 6px;
      border-right-width: 0;
      border-left-color: #000;
    }
  }

  .slides {
    position: relative;
    width: 100%;
    height: auto;
    border-top: 2px solid #daddf7;
    overflow-y: auto;

    > div {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 60px;
      position: relative;
      cursor: pointer;
      &:hover {
        color: #5778fb;
        .template {
          background: url("../../../static/svg/materialPane/navBtns/template-active.svg")
            no-repeat center;
        }
        .scene {
          background: url("../../../static/svg/materialPane/navBtns/scene-active.svg")
            no-repeat center;
        }
        .bg {
          background: url("../../../static/svg/materialPane/navBtns/bg-active.svg")
            no-repeat center;
        }
        .text {
          background: url("../../../static/svg/materialPane/navBtns/text-active.svg")
            no-repeat center;
        }
        .character {
          background: url("../../../static/svg/materialPane/navBtns/character-active.svg")
            no-repeat center;
        }
        .prop {
          background: url("../../../static/svg/materialPane/navBtns/prop-active.svg")
            no-repeat center;
        }
        .gif {
          background: url("../../../static/svg/gif-active.svg") no-repeat center;
        }
        .shape {
          background: url("../../../static/svg/shape-active.svg") no-repeat
            center;
        }
        .music {
          background: url("../../../static/svg/materialPane/navBtns/music-active.svg")
            no-repeat center;
        }
        .personal {
          background: url("../../../static/svg/personal-active.svg") no-repeat
            center;
        }
        .team {
          background: url("../../../static/svg/userExtensions00.svg") no-repeat
            center;
        }
      }

      i {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
      .template {
        background: url("../../../static/svg/materialPane/navBtns/template.svg")
          no-repeat center;
      }
      .scene {
        background: url("../../../static/svg/materialPane/navBtns/scene.svg")
          no-repeat center;
      }
      .bg {
        background: url("../../../static/svg/materialPane/navBtns/bg.svg")
          no-repeat center;
      }
      .text {
        background: url("../../../static/svg/materialPane/navBtns/text.svg")
          no-repeat center;
      }
      .character {
        background: url("../../../static/svg/materialPane/navBtns/character.svg")
          no-repeat center;
      }
      .prop {
        background: url("../../../static/svg/materialPane/navBtns/prop.svg")
          no-repeat center;
      }
      .gif {
        background: url("../../../static/svg/gif.svg") no-repeat center;
      }
      .shape {
        background: url("../../../static/svg/shape.svg") no-repeat center;
      }
      .music {
        background: url("../../../static/svg/materialPane/navBtns/music.svg")
          no-repeat center;
      }
      .personal {
        background: url("../../../static/svg/personal.svg") no-repeat center;
      }
      .team {
        background: url("../../../static/svg/userExtensions01.svg") no-repeat
          center;
      }
      .active-border {
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background-color: #5778fb;
      }

      .searchTag_out,
      .searchTag {
        position: absolute;
        top: 5px;
        right: 20%;
        height: 19px;
        border-radius: 10px;
        line-height: 18px;
        font-size: 14px;
        text-align: center;
        padding: 0 3px;
        min-width: 25px;
        color: #fff;
      }
      .searchTag {
        background: #e84848;
        z-index: 10;
      }
      .searchTag_out {
        background: #8c88a1;
        z-index: 10;
      }
    }
  }

  .is-active {
    background-color: #fff;
    color: #5778fb;
  }
  .ban-active {
    color: #8c88a1;
  }
  .template-active {
    background: url("../../../static/svg/materialPane/navBtns/template-active.svg")
      no-repeat center;
  }
  .scene-active {
    background: url("../../../static/svg/materialPane/navBtns/scene-active.svg")
      no-repeat center;
  }
  .bg-active {
    background: url("../../../static/svg/materialPane/navBtns/bg-active.svg")
      no-repeat center;
  }
  .text-active {
    background: url("../../../static/svg/materialPane/navBtns/text-active.svg")
      no-repeat center;
  }
  .character-active {
    background: url("../../../static/svg/materialPane/navBtns/character-active.svg")
      no-repeat center;
  }
  .prop-active {
    background: url("../../../static/svg/materialPane/navBtns/prop-active.svg")
      no-repeat center;
  }
  .gif-active {
    background: url("../../../static/svg/gif-active.svg") no-repeat center;
  }
  .shape-active {
    background: url("../../../static/svg/shape-active.svg") no-repeat center;
  }
  .music-active {
    background: url("../../../static/svg/materialPane/navBtns/music-active.svg")
      no-repeat center;
  }
  .personal-active {
    background: url("../../../static/svg/personal-active.svg") no-repeat center;
  }
  .team-active {
    background: url("../../../static/svg/userExtensions00.svg") no-repeat center;
  }

  .template-ban {
    background: url("../../../static/svg/scene-gray.svg") no-repeat center !important;
  }
  .scene-ban {
    background: url("../../../static/svg/scene-2-gray.svg") no-repeat center !important;
  }
  .bg-ban {
    background: url("../../../static/svg/bg-gray.svg") no-repeat center !important;
  }
  .text-ban {
    background: url("../../../static/svg/text-gray.svg") no-repeat center !important;
  }
  .character-ban {
    background: url("../../../static/svg/character-gray.svg") no-repeat center !important;
  }
  .prop-ban {
    background: url("../../../static/svg/prop-gray.svg") no-repeat center !important;
  }
  .gif-ban {
    background: url("../../../static/svg/gif-gray.svg") no-repeat center !important;
  }
  .shape-ban {
    background: url("../../../static/svg/shape-gray.svg") no-repeat center !important;
  }
  .music-ban {
    background: url("../../../static/svg/music-gray.svg") no-repeat center !important;
  }
  .personal-ban {
    background: url("../../../static/svg/personal-gray.svg") no-repeat center !important;
  }
  .team-ban {
    background: url("../../../static/svg/userExtensions02.svg") no-repeat center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/btns.vue